import { render, staticRenderFns } from "./sys_menu.vue?vue&type=template&id=0131ddb6&scoped=true"
import script from "./sys_menu.vue?vue&type=script&lang=js"
export * from "./sys_menu.vue?vue&type=script&lang=js"
import style0 from "./sys_menu.vue?vue&type=style&index=0&id=0131ddb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131ddb6",
  null
  
)

export default component.exports